import { useErrorLoggingInit } from '../../hooks/useErrorLoggingInit';

export const ErrorLoggingInitializer = (): null => {
    useErrorLoggingInit();
    return null;
};
